const initMapEvents = async (map) => {

    const state = {
        activeMapCard:null,
        activeMarker:null,
    }


    window.addEventListener('click', (e) => {

        if (e.target !== state.activeMapCard && e.target !== state.activeMarker?.firstChild){
            removeExistingMapCard();
        }
    });

    const removeExistingMapCard = () => {
        let cards = document.querySelectorAll('.mapcard');
        if (cards) {
            cards.forEach(c => c.remove());
        }
        state.activeMapCard = null;
        state.activeMarker = null;
    }


    const openMapCard = (e) => {

        removeExistingMapCard();
        // create div element for popup
        var div = document.createElement('div');
        div.className = 'mapcard';

        div.innerHTML = `<a href="${e.slug}" class='mapcard-wrapper'><span>${e.title}</span></a>`
        // append to body
        e.icon.appendChild(div);
        state.activeMapCard = div;
        state.activeMarker = e.icon;
        //console.log([...e.latlng])
        map.flyTo([...e.latlng],   map.zoom, { duration: 1 })
    }

    window.addEventListener('openproject', (e) => {

        openMapCard(e.detail);
    });


}

export const createMap = () => {

    Alpine.data("generateMap", () => ({
            filteredProjects: [],
            projects: null,
            map: null,
            customIcon: L.divIcon({
                className: 'custom-icon',
                html: '<div style="background-color: var(--theblue); width: 10px; height: 10px;"></div>',
                iconSize: [20, 20]
            }),
            markers: [],


            initialize(projectsraw) {

                this.projects = projectsraw.map(p => {
                    let position = p.fields.position?.[0];
                    return {
                        cat: p.categories,
                        title: p.post_title,
                        slug: p.slug,
                        position: position ? [position.lat, position.long] : null,
                    }
                })


                this.map = L.map(this.$el, {attributionControl: false,zoomControl:false}).setView([52.5200, 13.4050], 13);

                L.tileLayer('https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}{r}.{ext}?api_key=21954cce-f896-4ade-945f-e869c26a760f', {
                    minZoom: 12,
                    maxZoom: 15,
                    attribution: "nope",
                    //attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    ext: 'png'
                }).addTo(this.map);

                this.map.setZoom(12);
                initMapEvents(this.map);

            },


            createMarkers() {

                this.markers.forEach(m => m.remove());
                this.markers = [];

                this.filteredProjects.forEach(p => {

                    let marker = L.marker(p.position, {icon: this.customIcon});
                    this.markers.push(marker);

                    marker.addTo(this.map).on('click', function (e) {

                        let ev = new CustomEvent('openproject', {
                            detail: {
                                icon: e.target._icon,
                                slug: p.slug,
                                title: p.title,
                                latlng:p.position,
                                position: e.containerPoint
                            }
                        });
                        window.dispatchEvent(ev);
                    });


                });
            },

            showCategories(cat) {
                if (this.cat === cat) return;
                this.cat = cat;
                this.filterMarkers();
            },

            filterMarkers() {
                this.filteredProjects = this.projects.filter(p => {

                    return (p.cat.includes(this.cat)) || ["Alle", ""].includes(this.cat)
                })

                this.createMarkers();

            },

            zoom(faktor){
                this.map.setZoom(this.map.getZoom() + faktor);
            }

        })
    )


}